import {LoadingButton} from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../api/axios';
import {apiBaseUrl} from '../../api/urls';
import {CloseSnackbarAction} from '../common/CloseSnackbarButton';
import SnackbarMessages from '../common/SnackbarMessages';

interface Props extends Omit<DialogProps, 'onClose'> {
  groupId?: number | null;
  onSubmitted?: () => void;
  onClose?: () => void;
}

const AssetHumanGroupMessageClearModal = ({
  groupId,
  onSubmitted,
  onClose,
  ...props
}: Props) => {
  const {enqueueSnackbar} = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async (groupId?: number | null) => {
    setIsSubmitting(true);
    try {
      const endpoint = `${apiBaseUrl}/group-message`;
      await API.delete(endpoint, {
        params: {
          id: groupId ?? undefined,
        },
      });
      const message = `Chat successfully cleared`;
      enqueueSnackbar(message, {
        variant: 'success',
        action: CloseSnackbarAction,
      });
      onSubmitted?.();
      onClose?.();
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, "STRA_d51cfc21");
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }
    setIsSubmitting(false);
  };

  return (
    <Dialog {...props} onClose={onClose}>
      <DialogTitle>Clear Group Chat</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Are you sure you want to clear this chat?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose?.()}>Cancel</Button>
        <LoadingButton
          variant="contained"
          loading={isSubmitting}
          autoFocus
          onClick={() => submit(groupId)}
          color="warning"
        >
          Clear Chat
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default AssetHumanGroupMessageClearModal;
